import { Chip, Tooltip } from "@mui/material";
import { Invoice, LatestPaymentStateEnum } from "../generated/backendClient";
import { INVOICE_STATUS_LABEL_AND_COLOR } from "../backoffice.utils";
import { formatCents } from "../misc/Money";
import { useStudentLabelPalette } from "../hooks/useStudentLabelPalette";

// Dispute states from LatestPaymentStateEnum
const DISPUTE_STATES: LatestPaymentStateEnum[] = [
  "STRIPE_DISPUTED",
  "STRIPE_DISPUTE_EVIDENCE_SUBMITTED",
  "STRIPE_DISPUTE_WON",
  "STRIPE_DISPUTE_LOST",
];

export function getInvoiceStateLabel(invoice: Invoice): string {
  if (invoice.state === "PAYMENT_REVOKED") {
    // Check if the latest payment state is a dispute state
    if (invoice.latest_payment_state && DISPUTE_STATES.includes(invoice.latest_payment_state)) {
      return "Angefochten";
    } else {
      return "Fehlgeschlagene Zahlung";
    }
  }
  if (invoice.state === "REFUNDED") {
    if (invoice.payment === null) {
      return "Ausgebucht";
    } else {
      return "Erstattet";
    }
  }

  // For all other states, use the default label
  return INVOICE_STATUS_LABEL_AND_COLOR[invoice.state]?.label || "Unbekannt";
}

export function getInvoiceStateTooltip(invoice: Invoice): string {
  if (invoice.state === "PARTIALLY_REFUNDED") {
    const remainingPaidCents = Math.round(parseFloat(invoice.total_paid_gross.amount) * 100);
    const refundedCents = Math.round(parseFloat(invoice.refunded_amount.amount) * 100);
    return `Bezahlt ${formatCents(remainingPaidCents)}\nErstattet ${formatCents(refundedCents)}`;
  }

  return getInvoiceStateLabel(invoice);
}

export function InvoiceStateBadge(props: { invoice: Invoice }) {
  const { invoice } = props;
  const studentLabelColors = useStudentLabelPalette();
  const status = INVOICE_STATUS_LABEL_AND_COLOR[invoice.state];
  const colors = studentLabelColors[status.labelColor];
  const label = getInvoiceStateLabel(invoice);
  const tooltip = getInvoiceStateTooltip(invoice);

  return (
    <Tooltip title={<span style={{ whiteSpace: "pre-line" }}>{tooltip}</span>} placement="bottom-end">
      <Chip
        sx={{
          backgroundColor: colors.background,
          color: colors.text,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: 65,
          height: 20,
          fontSize: "10px",
          fontWeight: "500",
          lineHeight: 2,
        }}
        label={label}
      />
    </Tooltip>
  );
}
